import { FunctionComponent } from 'react';
import { Home } from './routes/Home';
import { DynamicNews } from './routes/DynamicNews';
import { Secretary } from './routes/Secretary';
import { ServiceList } from './routes/ServiceList';
import { Catalog } from './routes/Catalog';
import { News } from './routes/News';
import { Department } from './routes/Department';
import { Medicines } from './routes/Medicines';
import { PrivacyAndPolicies } from './routes/PrivacyAndPolice';

interface IRoutes {
  path: string;
  component: FunctionComponent<any>;
  exact?: boolean;
  private?: boolean;
}

export const ROUTES = {
  HOME_PAGE: '/',
  DEPARTMENT_LIST_PAGE: '/orgaos-e-secretarias',
  DEPARTMENT_PAGE: '/orgaos-e-secretarias/:orgao',
  SERVICE_LIST_PAGE: '/carta-de-servicos',
  SEARCH_SERVICE_PAGE: '/search/:slug',
  SERVICE_PAGE: '/carta-de-servicos/:service',
  NEWS_PAGE: '/noticias',
  DYNAMIC_NEWS_PAGE: '/noticias/:newsType',
  MEDICINES_LIST_PAGE: '/consulta-medicamentos-padronizados-no-estado',
  PRIVACY_POLICIES_PAGE: '/politicas-de-privacidade',
  DEFAULT_PAGE: '*',
};

export const routes: IRoutes[] = [
  { path: ROUTES.HOME_PAGE, component: Home, exact: true },
  { path: ROUTES.NEWS_PAGE, component: News, exact: true },
  { path: ROUTES.DYNAMIC_NEWS_PAGE, component: DynamicNews, exact: true },
  { path: ROUTES.DEPARTMENT_LIST_PAGE, component: Secretary, exact: true },
  { path: ROUTES.DEPARTMENT_PAGE, component: Department, exact: true },
  { path: ROUTES.SERVICE_LIST_PAGE, component: ServiceList, exact: true },
  { path: ROUTES.MEDICINES_LIST_PAGE, component: Medicines, exact: true },
  { path: ROUTES.SEARCH_SERVICE_PAGE, component: ServiceList },
  { path: ROUTES.SERVICE_PAGE, component: Catalog },
  { path: ROUTES.PRIVACY_POLICIES_PAGE, component: PrivacyAndPolicies },
  { path: ROUTES.DEFAULT_PAGE, component: Home },
];
